import { render, staticRenderFns } from "./Climates.vue?vue&type=template&id=909431c6&"
import script from "./Climates.vue?vue&type=script&lang=js&"
export * from "./Climates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports